import { ReactNode } from "react"
import { AppShell } from "@/components/shell/AppShell"
import { ThemeProvider } from "@/components/theme/ThemeProvider"

interface AppLayoutProps {
  children: ReactNode
}

export default function AppLayout({ children }: AppLayoutProps) {
  return (
    <ThemeProvider>
      <AppShell>{children}</AppShell>
    </ThemeProvider>
  )
}
